module.exports = __webpack_public_path__ + "img/user-default.e28e794c.png";